import { Reducer } from 'redux'
import _ from 'lodash'
import { Profile } from './types'
import * as actions from './actions'

export type ProfileState = Readonly<{
  profiles: Record<string, Profile>
  isLoading: boolean
}>

export const initState: ProfileState = {
  profiles: {},
  isLoading: false
}

export const profileReducer: Reducer<ProfileState, actions.ProfileActions> = (state = initState, action) => {
  switch (action.type) {
    case actions.FETCH_PROFILES_SUCCESS:
      return {
        ...state,
        profiles: { ..._.keyBy(action.payload, 'id') }
      }
    default:
      return state
  }
}
